import React from 'react';
interface BrandRaysProps {
  /** Which corner the rays emanate from */
  origin?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  /** Number of rays (3-7) */
  rayCount?: number;
  /** Overall size */
  size?: number;
  className?: string;
}
/**
 * Deconstructed rays from the GTH fan mark.
 * Angular wedges radiating from a focal point in brand colors.
 * Use as editorial accents at section edges — partial, cropped, suggestive.
 */
export function BrandRays({
  origin = 'bottom-right',
  rayCount = 5,
  size = 400,
  className = ''
}: BrandRaysProps) {
  // Brand palette — extracted from the fan mark
  const rayColors = ['#1A2838', '#3D6B7E', '#8BA89F', '#2D4A5E', '#A8C4BB', '#1A2838', '#5A8A7A' // muted seaglass
  ];
  // Rotation transforms based on origin
  const originRotation: Record<string, number> = {
    'bottom-right': 0,
    'bottom-left': 90,
    'top-right': -90,
    'top-left': 180
  };
  const rotation = originRotation[origin];
  // Generate ray paths — angular wedges from origin point
  const rays = [];
  const spreadAngle = 65; // total spread in degrees
  const startAngle = -spreadAngle / 2;
  const angleStep = spreadAngle / (rayCount + 1);
  const rayWidth = angleStep * 0.65; // gap between rays
  for (let i = 0; i < rayCount; i++) {
    const angle = startAngle + angleStep * (i + 1);
    const a1 = (angle - rayWidth / 2) * Math.PI / 180;
    const a2 = (angle + rayWidth / 2) * Math.PI / 180;
    const len = size * 1.2;
    // Ray emanates from bottom-right corner (0,0 after transform)
    const x1 = -Math.cos(a1) * len;
    const y1 = -Math.sin(a1) * len;
    const x2 = -Math.cos(a2) * len;
    const y2 = -Math.sin(a2) * len;
    rays.push(<polygon key={i} points={`0,0 ${x1},${y1} ${x2},${y2}`} fill={rayColors[i % rayColors.length]} opacity={0.85 - i * 0.08} data-id="element-35" />);
  }
  return <div className={`overflow-hidden pointer-events-none ${className}`} data-id="element-36">
      <svg width={size} height={size} viewBox={`${-size} ${-size} ${size} ${size}`} xmlns="http://www.w3.org/2000/svg" style={{
      transform: `rotate(${rotation}deg)`
    }} data-id="element-37">
        {rays}
      </svg>
    </div>;
}